module.exports = __webpack_public_path__ + "static/media/Edit.f7b4be3b.svg";